export default __webpack_public_path__ + "static/media/13.1c4d2eb7.jpg";